import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as P from './PopularFacility.styles';
import OneFourGauge from './Gauges/OneFourGauge';
import HalfGauge from './Gauges/HalfGauge';
import ThreeFourGauge from './Gauges/ThreeFourGauge';
import { facilityService, LiveSeatInfo } from 'services/facilityService';

const PopularFacility: React.FC = () => {
  const navigate = useNavigate();
  const [seatInfo, setSeatInfo] = useState<LiveSeatInfo[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchSeatInfo = async () => {
      try {
        const response = await facilityService.getLiveSeatInfo(0, 5);
        setSeatInfo(response.content);
      } catch (error) {
        console.error('Failed to fetch live seat info:', error);
        setSeatInfo([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSeatInfo();
  }, []);

  const handleClick = () => {
    navigate('/popularfacility/placestates');
  };

  const getGaugeComponent = (occupiedSeats: number, totalSeats: number) => {
    const ratio = occupiedSeats / totalSeats;
    if (ratio >= 2/3) return <ThreeFourGauge />;
    if (ratio >= 1/3) return <HalfGauge />;
    return <OneFourGauge />;
  };

  return (
    <P.EntirePopularFacilityBack>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <p style={{ fontWeight: 'bold', fontSize: '18px', margin: 0 }}>열람실 현황</p>
        <p
          onClick={handleClick}
          style={{
            fontSize: '12px',
            color: '#414247',
            fontWeight: '400',
            margin: 0,
            cursor: 'pointer',
          }}
        >
          전체보기
        </p>
      </div>

      {isLoading ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>로딩 중...</div>
      ) : seatInfo.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>열람실 정보가 없습니다.</div>
      ) : (
        seatInfo.map((info) => (
          <P.SemiPopularFacilityBack key={info.facilityName}>
            <P.PlaceName>{info.facilityName}</P.PlaceName>
            <P.GaugeBack>
              <P.GaugeNumbers>
                <span>{info.occupiedSeats}</span>
                <span>{info.totalSeats}</span>
              </P.GaugeNumbers>
              {getGaugeComponent(info.occupiedSeats, info.totalSeats)}
            </P.GaugeBack>
          </P.SemiPopularFacilityBack>
        ))
      )}
    </P.EntirePopularFacilityBack>
  );
};

export default PopularFacility;
